module.exports = __webpack_public_path__ + "static/img/com5.a1ad775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/solution/imgs/com5.jpg
// module id = Y7vU
// module chunks = 1